import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros, all = false) {
  return httpAuth.get(`/admin/alertas?${serialize({ ...filtros, all })}`, {
    tela: 'alertas'
  })
}

export async function add (funcionalidade, dados) {
  return httpAuth.post('/admin/alertas', dados, { funcionalidade: funcionalidade })
}

export async function edit (funcionalidade, id, dados) {
  return httpAuth.put(`/admin/alertas/${id}`, dados, { funcionalidade: funcionalidade })
}

export async function del (funcionalidade, id) {
  return httpAuth.delete(`/admin/alertas/${id}`, { funcionalidade: funcionalidade })
}
